import React from 'react';
import { FiAlertTriangle, FiCheck, FiX } from 'react-icons/fi';
import Modal from './Modal';
import Button from './Button';
import './ConfirmDialog.css';

const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Yes',
  cancelText = 'Cancel',
  variant = 'warning', // warning, danger, info
  loading = false,
  icon = null
}) => {
  const getIcon = () => {
    if (icon) return icon;
    
    switch (variant) {
      case 'danger':
        return <FiX className="confirm-icon danger" />;
      case 'info':
        return <FiCheck className="confirm-icon info" />;
      case 'warning':
      default:
        return <FiAlertTriangle className="confirm-icon warning" />;
    }
  };

  const getVariantClass = () => {
    switch (variant) {
      case 'danger':
        return 'confirm-dialog--danger';
      case 'info':
        return 'confirm-dialog--info';
      case 'warning':
      default:
        return 'confirm-dialog--warning';
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="small"
      className={`confirm-dialog ${getVariantClass()}`}
      showCloseButton={false}
    >
      <div className="confirm-dialog__content">
        <div className="confirm-dialog__icon">
          {getIcon()}
        </div>
        
        <div className="confirm-dialog__text">
          <h3 className="confirm-dialog__title">{title}</h3>
          <p className="confirm-dialog__message">{message}</p>
        </div>
      </div>
      
      <div className="confirm-dialog__actions">
        <Button
          variant="outline"
          onClick={onClose}
          disabled={loading}
        >
          {cancelText}
        </Button>
        <Button
          variant={variant === 'danger' ? 'danger' : 'primary'}
          onClick={onConfirm}
          loading={loading}
        >
          {confirmText}
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmDialog;